import { define } from '../../define.js';
import { SegmentedControl } from './segmented-control.js';
export * from './segmented-control.js';
define('segmented-control', SegmentedControl);
